import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { URLs } from '../../../constants/URLS';
import { AnalyticsService } from '../../../services/analytics.service';
import { AuthGuard } from '../../../guard/auth.guard';
import { CONFIG } from '../../../constants/lottie.constants';
import { CODIGOS_ERROR, ERRORES } from '../../../constants/errores.constants';

@Component({
  selector: 'app-mensaje-warning',
  templateUrl: './mensaje-warning.component.html',
  styleUrls: ['./mensaje-warning.component.scss']
})
export class MensajeWarningComponent implements OnInit {
  public window = window;
  config = undefined;
  buttonVolver = {
    text: 'VOLVER AL HOME',
    class: 'btn-neutral',
    type: 'button'
  };
  lottieInfo = CONFIG.WARN;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly analyticsService: AnalyticsService,
    private readonly authGuard: AuthGuard
  ) {
    this.authGuard.setActivated = false;
    const errorCode = this.activatedRoute.snapshot.queryParamMap.get('type');
    this.config = ERRORES[errorCode] || ERRORES[CODIGOS_ERROR.INTERNAL];
    this.lottieInfo = CONFIG[this.config.tipo];
  }

  ngOnInit() {
    this.analyticsService.mensaje({
      label: this.config.titulo,
      action: 'view',
      channel: 'browser',
      element_id: undefined,
      type: 'alert warning',
      section: 'inicio'
    });
  }

  toggleActive() {
    this.window.location.href = URLs.home;
  }
}
